import { breadcrumbSchema, faqPageSchema, schemaGraph } from "~/lib/seo/schema";
import { ATS_EVIDENCE_LANDING_PATH } from "~/lib/seo/public-landing-routes";

export const ATS_EVIDENCE_CONTENT_KEYS = [
  "ats-evidence-de-2026-10-07",
  "transparent-ai-de-2026-10-07",
] as const;

export const ATS_EVIDENCE_PATH = ATS_EVIDENCE_LANDING_PATH;
export const ATS_EVIDENCE_URL = `https://alchema.eu${ATS_EVIDENCE_PATH}` as const;
export const ATS_EVIDENCE_TITLE =
  "ATS-Lebenslauf prüfen: Anforderungen belegen | Alchema";
export const ATS_EVIDENCE_DESCRIPTION =
  "Ordne Anforderungen aus einer Stellenanzeige echten Erfahrungen im Lebenslauf zu. Fehlende Nachweise bleiben sichtbar, statt erfunden zu werden.";
export const ATS_EVIDENCE_HEADING =
  "ATS-Lebenslauf prüfen: Anforderungen mit echten Belegen abgleichen";
export const ATS_TRANSPARENT_AI_HEADING =
  "KI im Lebenslauf: formulieren helfen, nichts erfinden";
export const ATS_EVIDENCE_CTA_LABEL =
  "Anforderungen mit deinem Lebenslauf vergleichen";

export interface AtsEvidenceFaq {
  readonly question: string;
  readonly answer: string;
}

export const ATS_EVIDENCE_FAQS = [
  {
    question: "Darf KI fehlende Erfolge ergänzen?",
    answer:
      "Nein. Fehlende oder unklare Angaben müssen sichtbar bleiben und von der Person selbst bestätigt werden.",
  },
  {
    question: "Was bedeutet „KI-gestützt“?",
    answer:
      "Die KI unterstützt einzelne Schritte; die Person prüft, bearbeitet und bestätigt das Ergebnis.",
  },
  {
    question: "Garantiert ein ATS-Score ein Interview?",
    answer:
      "Nein. Ein technischer Check ist eine Diagnosehilfe, keine Einstellungsprognose.",
  },
  {
    question: "Wie prüfe ich KI-generierte Aussagen?",
    answer:
      "Vergleiche jede Aussage mit realen Stationen, Projekten, Daten und Ergebnissen.",
  },
] as const satisfies readonly AtsEvidenceFaq[];

export const ATS_EVIDENCE_ROWS = [
  {
    requirement: "Projektmanagement mit Jira",
    evidence: "Im Lebenslauf ist die Koordination von Aufgaben mit Jira beschrieben.",
    wordingGap: "Verantwortung und Einsatzkontext können genauer benannt werden.",
    status: "belegt",
  },
  {
    requirement: "Deutschkenntnisse auf Niveau C1",
    evidence: "Der Lebenslauf nennt Deutschkenntnisse, aber kein belegtes Niveau.",
    wordingGap: "Das geforderte Sprachniveau ist nicht eindeutig nachgewiesen.",
    status: "unklar",
  },
  {
    requirement: "AWS-Zertifizierung",
    evidence: "Im Lebenslauf ist keine entsprechende Zertifizierung angegeben.",
    wordingGap: "Ein vorhandener Nachweis müsste ergänzt werden; ohne Nachweis bleibt die Anforderung offen.",
    status: "fehlt",
  },
] as const;

export const ATS_EVIDENCE_LINKS = {
  register: "/register",
  privacy: "/privacy",
  pricing: "/pricing",
  coverLetters: "/cover-letters",
  din5008: "/de/lebenslauf-generator-din-5008",
  aiTransparency: "/about",
} as const;

export const ATS_EVIDENCE_AI_TRANSPARENCY_HASH = "article-50";

export const ATS_EVIDENCE_ARTICLE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Article",
  "@id": `${ATS_EVIDENCE_URL}#article`,
  headline: ATS_EVIDENCE_HEADING,
  description: ATS_EVIDENCE_DESCRIPTION,
  datePublished: "2026-10-07",
  author: {
    "@type": "Organization",
    "@id": "https://alchema.eu/#organization",
    name: "Alchema",
  },
  publisher: {
    "@type": "Organization",
    "@id": "https://alchema.eu/#organization",
    name: "Alchema",
  },
  mainEntityOfPage: {
    "@type": "WebPage",
    "@id": ATS_EVIDENCE_URL,
  },
  inLanguage: "de",
} as const;

export const ATS_EVIDENCE_SCHEMA_GRAPH = schemaGraph(
  ATS_EVIDENCE_ARTICLE_SCHEMA,
  faqPageSchema([...ATS_EVIDENCE_FAQS]),
  breadcrumbSchema([
    { name: "Start", url: "/" },
    { name: ATS_EVIDENCE_HEADING, url: ATS_EVIDENCE_PATH },
  ]),
);
